/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
function t(t,n,c){const{associationType:e}=t;switch(e){case"attachment":return"to"===n?c.attachment:c.structure;case"containment":return"to"===n?c.content:c.container;case"junction-edge-from-connectivity":case"junction-edge-to-connectivity":case"junction-edge-midspan-connectivity":case"junction-junction-connectivity":case"connectivity":return c.connectivity}}export{t as getAssociationTitle};
